module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "_idContainer011",
      "role": "doc-chapter"
    }
  }, [_c('h1', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("Chapter Four")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("D")]), _vm._v("ane found Cook in the pantry, sorting through institutional cans of tomato soup.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Barbecue tonight?” he asked the bony old ranch hand.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“If I can find the molasses,” Cook said over his shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“If we’re out, I’ll make a run to town.” The boys loved that recipe. “Cook, did Blaze get into the medicine chest?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The older man turned and frowned at him. “Why would he do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He had an injury out in the barn lot. Gordy got after us.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That blamed ol’ cow’s going to get somebody kilt someday. Since when did you start calling him Blaze?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Oops. “Since three seconds ago. I’d better go see about him.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dane took the stairs and saw a spot of blood on the railing. He went to the closed door of the bedroom Gavin and Willy shared. When he pushed it open he saw Gavin in the center of the room, holding the end of a syringe against the bare flesh of his stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What are you doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m a bleeder.” The boy wiped a smudge of blood from his arm.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’s in the syringe?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“A coagulant to stop the flow.” He rewrapped the syringe and set it on the top of his dresser.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nobody told me,” Dane said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not a lot of people know.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How could you keep something like that a secret?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You don’t believe me?” Again, that expression of irritable impatience, thick brows lowered over eyes narrowed with disappointment.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I didn’t say that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Gavin sat on the chest in front of the window that overlooked the barn. “About two years ago my old doctor died, and nobody took his place. The guy was in his eighties, only had a few patients. My prescription for this stuff’s always refillable, so I didn’t go to a new doc for a while. When I did, he never said anything about sending him my old records. I guess they kind of got lost.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s dangerous, Blaze. You need to take responsibility for your own health care now. What would happen if you ran out—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’d you call me?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Oh, no. He’d done it again.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You called me Blaze.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Happy birthday. Why didn’t your mother tell the social worker about your condition?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She doesn’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I can’t believe she wouldn’t—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“There you go again.” Blaze shook his head and gestured toward the bed. “You want to sit down and let me tell you a few facts of life?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I want to know where Clint can get a copy of your medical records.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Blaze unwrapped a paper towel from around his wrist. “See? The stuff’s already working. No big deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s a big deal when we don’t know—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thing is, I didn’t figure they’d let me come to the ranch if they knew I was a bleeder. You know, working with the animals can be a little tricky sometimes. But I’ve got this—” his voice wavered “—this need to be around....” He swallowed and studied the wound on his wrist.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s okay,” Dane said. “I think I understand. You probably worked with your father a lot in his practice.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You lived in Rolla?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Edge of town. Saw my mother maybe three times after the divorce was final, and maybe six times before that. Until Dad died.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“About what? That my own mother doesn’t want me? Not your fault. You ever put any ice on that thigh?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I will.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sure. You gonna kick me out?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You got any other secrets you need to tell me?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m not an arsonist.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s no secret.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t think I’ll make it at school.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dane eased himself onto the bed at last, groaning at the increased soreness of his leg. “Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t read too well.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You need glasses?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ve got good vision, I just can’t catch on to reading.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe I can help you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How’re you going to do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Has anybody ever suggested you might have a learning disability?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All my life.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Your father could have helped you—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t you say anything about my father,” Blaze snapped. “He got dumped by the same woman who dumped me. He did the best he could, but he was busy.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe you need to learn a different way to process information.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I process just fine—I just can’t read the letters.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Backward? Maybe if we played with that a little.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe you should just use me here on the ranch to take care of the animals. Maybe that’s all I need to do. I could just be a ranch hand here on the place.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I didn’t bring you here to work. I brought you here to take care of you. That means you get an education.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Blaze hooked his thumbs into his belt loops. “I’d like to see you try.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’d better believe I will.”")]), _vm._v(" "), _c('hr', {
    staticClass: "tb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_vm._v("Hothouse flowers saturated the atmosphere, nauseating Cheyenne as she slid into the pew beside her mother. Organ music threaded through the gloom of the church, trickling over her like black oil, punctuated by her mother’s quiet sobs. She felt oppressed by the crowd in this auditorium, though she knew the outpouring of kindness by so many should give her comfort.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But nothing could give her comfort. Some evil entity had gut-kicked her, and it amazed her that she was still breathing.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Kirk sat across the auditorium, wiping his face with a white handkerchief. In a haze of pain this past weekend, Cheyenne had tried twice to contact him. No response. Her parents had called his number three times yesterday. No answer. No matter what had transpired before now, he must be hurting horribly.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cheyenne’s fingernails sank into the flesh of her hand. Could he be hurting worse than she was? She had lived with the nightmare of seeing her beloved baby sister—her only sibling—wheeled into the ER mangled and bloody. She had plunged her hands into the blood, had fought desperately for Susan’s life. She had lost.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("If not for the overwhelming support of extended family—aunts, uncles, cousins—Cheyenne wouldn’t be able to handle this day, or her parents’ grief. Or her own.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Mom hadn’t stopped crying since she and Dad arrived yesterday. Dad looked closer to seventy than fifty-six.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A young minister sat on the stage behind the podium, fidgeting with his tie.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Someone touched Cheyenne on the shoulder. She looked up to see Ardis Dunaway standing in the aisle, her dark eyes peering through bifocals with deep compassion.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How’re you holding up, hon?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cheyenne nodded. She still wanted to die. “I don’t know how to thank you for all you’ve done to help these past few days.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t you even worry about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Not only had this dear friend taken care of her when she collapsed the day of Susan’s death, but Ardis and Jim had been the ones to call Kirk in and tell him about Susan—a task Cheyenne would traditionally have undertaken.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ardis leaned closer. “Have you spoken to Kirk at all?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He won’t communicate.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“And so we still don’t know why she was driving under the influence—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Please.” Cheyenne felt the stab of fresh pain. “Does it matter, anyway? She’s dead, and no amount of fact finding will bring her back. The wreck wasn’t her fault, according to the police report. That’s all I need to—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m sorry, honey, of course you’re right.” Ardis squeezed her shoulder, then indicated the crowded church. “Look, I know you don’t believe in all this, but I hope it comforts you to know that Susan was very well loved.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“My sister found...comfort here, apparently,” Cheyenne said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She’s receiving more comfort now than she ever received here on earth.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cheyenne nodded, too overwhelmed to argue. She respected Ardis’s faith even though she didn’t share it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ardis squeezed Cheyenne’s shoulder and returned to her seat several rows back.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The organ music drifted to silence. The deep baritone voice of a soloist echoed through the auditorium—waxing poetic about gardens and dew and talking with the Son of God.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cheyenne focused her attention on the closed casket and the picture of her laughing sister, whose life hadn’t been lived long enough for her to ever be complete.")]), _vm._v(" "), _c('hr', {
    staticClass: "tb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_vm._v("At the cemetery, the funeral director escorted Cheyenne beneath the canopy to the seat next to her brother-in-law.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He edged away from her, his firm features set.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She endured the minister’s attempt at consolation as he eulogized her sister.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He meant well, but he didn’t know Susan the way she did.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She took her mother’s hand and held tight, forcing away the memories of Friday. Almost every night, she dreamed of the blood. She dreamed of Susan’s battered body. She relived that horrible time over and over in her head.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The pastor finished his eulogy and said a prayer, then reached for Kirk’s hand. “She was a precious soul,” he said softly. “We’ll miss her so much, but I know it’ll be nothing compared to what you’re going through.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Kirk’s tears looked real, the pain on his face unrehearsed. It reflected Cheyenne’s own loss.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("For one unguarded moment, she felt the kinship. As the pastor stepped away, Cheyenne touched Kirk’s arm. “We’re both going to miss her,” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He jerked away, turning on her with the swiftness of a striking snake. “How are you going to live with yourself, knowing you killed your own sister?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The viciousness of his words, his voice, sent a sting of shock through her. “How can you say that? I did everything I could to—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Save it for the jury.” He turned his broad back to her and stood.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cheyenne stood at the foot of the casket, barely heeding the voices that surrounded her as she watched Kirk shaking the hand of the funeral director. He waved and nodded to others, like a gracious party host.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He looked aside and caught her watching him. His expression hardened.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She stepped backward and stumbled.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Cheyenne? Are you okay?” Uncle Chester caught her by the elbow.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She felt a wash of dizziness. “I’m not sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Mom rushed to her side. “Chey? What’s wrong? Are you sick again?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, I... I’ll be okay.” How could he blame her? She’d done all she could do. She would gladly die herself, if only it would bring Susan back.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But nothing would bring Susan back—and Cheyenne didn’t know how she’d be able to bear it.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d16f8ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter_Four.vue
// module id = 87
// module chunks = 0